<template>
  <div>
    <authentication-forms-container :image="image">
      <form @submit.prevent="onSubmit" class="mt-2">
        <h4 class="text-primary" v-t="'reset_cellphone_password.title'"></h4>

        <div class="form-row">
          <div class="col">

            <div class="form-group mb-4">
              <label for="code" v-t="'authentication_general.cellphone_verification_code'"></label>
              <input v-model="form.code" type="text"
                     :placeholder="$t('authentication_general.cellphone_verification_code_placeholder')" name="code"
                     class="form-control text-left rounded-pill"
                     id="code">
              <form-errors-manager :validation="v$.form.code"/>
            </div>

          </div>
        </div>

        <div class="form-row">
          <div class="col">

            <div class="form-group mb-4">
              <label for="password" v-t="'authentication_general.password'"></label>
              <input v-model="form.password" type="password"
                     :placeholder="$t('authentication_general.password_placeholder')"
                     class="form-control rounded-pill"
                     id="password">
              <form-errors-manager :validation="v$.form.password"/>
            </div>


          </div>

          <div class="col">


            <div class="form-group mb-4">
              <label for="password_confirmation" v-t="'authentication_general.password_confirm'"></label>
              <input v-model="form.password_confirmation" type="password"
                     :placeholder="$t('authentication_general.password_confirm_placeholder')"
                     class="form-control rounded-pill"
                     id="password_confirmation">
              <form-errors-manager :validation="v$.form.password_confirmation"/>
            </div>

          </div>
        </div>

        <div class="my-4">
          <m-captcha1 v-model="form.captcha_answer"/>
          <form-errors-manager :validation="v$.form.captcha_answer"/>
        </div>

        <button type="submit" class="my-3 btn btn-primary rounded-pill btn-block   w-100"
                v-t="'reset_cellphone_password.submit_button'">
        </button>
        <a class="text-primary"
           v-t="'authentication_general.resend_code'"
           href="#"
           v-if="timerCount === 0"
           @click.prevent="resendCellphoneCodeForForgetPassword"
        ></a
        >
      </form>
    </authentication-forms-container>
  </div>
</template>

<script>
import {useVuelidate} from '@vuelidate/core'
import {sameAs, required, minLength, maxLength} from "@vuelidate/validators";
import FormErrorsManager from "../../validator/FormErrorsManager";
import {mapGetters} from "vuex";
import AuthenticationFormsContainer from "../Form/AuthFormsContainer";
import mCaptcha1 from "../../Captcha/Captcha1";
import {captchaValidation} from "../../Captcha/CaptchaValidation";
import {setSeoOnWrapper} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

export default {
  name: "CellphoneForgetPassword1",
  components: {FormErrorsManager, AuthenticationFormsContainer, mCaptcha1},
  setup() {
    return {v$: useVuelidate()}
  },
  data() {
    return {
      form: {
        code: "",
        password: "",
        password_confirmation: "",
        captcha_answer: ''
      },
      timerEnabled: true,
      timerCount: 120,
    };
  },
  watch: {
    timerEnabled(value) {
      if (value) {
        setTimeout(() => {
          this.timerCount--;
        }, 1000);
      }
    },

    timerCount: {
      handler(value) {
        if (value > 0 && this.timerEnabled) {
          setTimeout(() => {
            this.timerCount--;
          }, 1000);
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },
  props: {
    image: {
      type: String,
      default: null
    }
  },
  validations() {
    return {
      form: {
        code: {required},
        password: {required, minLength: minLength(4)},
        password_confirmation: {required, sameAsPassword: sameAs(this.formPassword)},
        captcha_answer: captchaValidation,
      },
    }
  },
  computed: {
    ...mapGetters({
      forgetPasswordCellphone: "Authentication/getCellphoneForForgetPassword",
    }),
    formPassword() {
      return this.form.password
    },
  },
  methods: {
    async onSubmit() {
      const result = await this.v$.form.$validate()
      if (!result) return

      let form = {
        cellphone: this.forgetPasswordCellphone.cellphone,
        code: this.form.code,
        password: this.form.password,
        password_confirmation: this.form.password_confirmation,
      };
      this.$store.dispatch("Authentication/cellphoneResetPassword", form);
    },

    resendCellphoneCodeForForgetPassword() {
      const c = {cellphone: this.forgetPasswordCellphone.cellphone};
      this.$store.dispatch("Authentication/resendCodeForCellphoneForgetPassword", c);
      this.resetTimer();
    },

    play() {
      this.timerEnabled = true;
    },

    pause() {
      this.timerEnabled = false;
    },
    resetTimer() {
      this.timerCount = 120;
      this.timerEnabled = true;
    },
  },
  mounted() {
    setSeoOnWrapper({},'cellphone-reset-password')
  }
};
</script>
<style scoped>

</style>